import { forEach } from 'lodash';

import { detectBlur, detectEdges } from 'utils/files/images';
import { notifyError } from 'utils/notifications';

export const flipImageHorizontally = ({ image }) => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  canvas.width = image.width;
  canvas.height = image.height;

  context.translate(canvas.width, 0);
  context.scale(-1, 1);
  context.drawImage(
    image,
    0,
    0,
    image.width,
    image.height,
    0,
    0,
    image.width,
    image.height
  );

  return canvas;
};

export const processMobileCapture = ({
  image,
  webcamRect,
  navRect,
  topNavPos
}) => {
  const capButtonTop = navRect.top + 2;
  const overflowingBottom = webcamRect.bottom > capButtonTop;
  const overflowingTop = webcamRect.top < topNavPos;

  if (!overflowingBottom && !overflowingTop) {
    return image.src;
  }

  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  const croppedHeight =
    (image.height * (capButtonTop - topNavPos)) / webcamRect.height;
  const startY = overflowingTop
    ? (image.height * (topNavPos - webcamRect.top)) / webcamRect.height
    : 0;

  canvas.width = image.width;
  canvas.height = croppedHeight;

  context.drawImage(
    image,
    0,
    startY,
    image.width,
    croppedHeight,
    0,
    0,
    image.width,
    croppedHeight
  );

  return canvas.toDataURL();
};

export const getBlurScoreFromBase64 = ({ image }) => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  canvas.width = 300;
  canvas.height = (300 * image.height) / image.width;

  context.drawImage(image, 0, 0, canvas.width, canvas.height);

  const blurScore = detectBlur(
    detectEdges(
      context.getImageData(0, 0, canvas.width, canvas.height),
      context,
      canvas
    ),
    context,
    canvas
  );

  return blurScore;
};

export const validateImageBlur = ({ blurScore, threshold }) => {
  if (blurScore < threshold) {
    return {
      isValid: false,
      error: {
        name: 'BlurError',
        message: 'The image is too blurry. Please try again.'
      }
    };
  }
  return { isValid: true, error: null };
};

export const getBlurScore = ({ image }) => {
  const canvas = document.createElement('canvas');
  canvas.width = image.width;
  canvas.height = image.height;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(image, 0, 0, image.width, image.height);
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  return detectBlur(detectEdges(imageData, ctx, canvas), ctx, canvas);
};

export const onDropRejected = ({ files }) =>
  forEach(files, (file) =>
    notifyError(`${file.name} exceeds the size limit of 20 MB.`)
  );
